import { getSavedLang } from "../utils/lang";

export const MEASUREMENT_PRODUCTION = "G-NDX9XPC0BZ";
export const MEASUREMENT_STAGING = "G-N2QEYPQHLM";

export const GTM_CURRENT = "GTM-MQM7TN8";
export const GTM_NEW = "GTM-K6BWVH73";

export function gtmContainerId(hostname) {
  const host = (hostname || "").toLowerCase();
  if (
    host === "fansfirst.ca" ||
    host === "www.fansfirst.ca" ||
    host === "development.fansfirst.ca"
  ) {
    return GTM_NEW;
  }
  return GTM_CURRENT;
}

let debugEnabledAtStartup = false;
let currentPageType = "other";

export function captureAnalyticsDebugFlag(enabled) {
  debugEnabledAtStartup = enabled === true;
}

export function getAnalyticsDebugAtStartup() {
  return debugEnabledAtStartup;
}

export function setCurrentPageType(pageType) {
  currentPageType = pageType || "other";
}

export function getCurrentPageType() {
  return currentPageType;
}

export function getHostname() {
  if (typeof window === "undefined" || !window.location) {
    return "";
  }
  return (window.location.hostname || "").toLowerCase();
}

export function resolvePageType(pathname) {
  const path = pathname || "/";
  if (path === "/" || path === "") {
    return "home";
  }
  if (/^\/[^/]+\/games\/?$/.test(path)) {
    return "games";
  }
  if (
    /^\/games\/[^/]+\/seats\/?$/.test(path) ||
    /^\/seats\/[^/]+\/[^/]+\/?$/.test(path) ||
    /^\/test-seats\/[^/]+\/[^/]+\/?$/.test(path)
  ) {
    return "seats";
  }
  if (
    /^\/games\/[^/]+\/seats\/[^/]+\/?$/.test(path) ||
    /^\/seats\/[^/]+\/[^/]+\/[^/]+\/?$/.test(path) ||
    /^\/test-seats\/[^/]+\/[^/]+\/[^/]+\/?$/.test(path)
  ) {
    return "ticket";
  }
  if (path === "/checkout" || path.startsWith("/checkout?")) {
    return "checkout";
  }
  if (/^\/thankyou\//.test(path)) {
    return "thank_you";
  }
  return "other";
}

export function getLanguage() {
  const saved = getSavedLang();
  if (saved === "fr" || saved === "en") {
    return saved;
  }
  return "en";
}

export function getMeasurementId() {
  const host = getHostname();
  if (host === "fansfirst.ca" || host === "www.fansfirst.ca") {
    return MEASUREMENT_PRODUCTION;
  }
  if (host === "development.fansfirst.ca" && debugEnabledAtStartup) {
    return MEASUREMENT_STAGING;
  }
  return null;
}

/**
 * Measurement id for browser gtag hits. Follows the same host rules as getMeasurementId:
 * - fansfirst.ca / www.fansfirst.ca → G-NDX9XPC0BZ (no debug_mode)
 * - development.fansfirst.ca + debug flag → G-N2QEYPQHLM (with debug_mode)
 * - every other host → null (no events sent)
 *
 * Production and development load GTM-K6BWVH73 only. The production GA4 tags in that
 * container stay paused. React owns GA4. See docs/analytics.md "GTM cutover".
 */
export function getBrowserMeasurementId() {
  return getMeasurementId();
}

const ANON_KEY = "ff_analytics_anonymous_id";

export function getAnonymousId() {
  if (typeof window === "undefined") {
    return "server";
  }
  try {
    let id = localStorage.getItem(ANON_KEY);
    if (!id) {
      id =
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : `anon-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(ANON_KEY, id);
    }
    return id;
  } catch {
    return `anon-${Date.now()}`;
  }
}
